import { render, staticRenderFns } from "./repairSettingList.vue?vue&type=template&id=c31c9786&scoped=true"
import script from "./repairSettingList.vue?vue&type=script&lang=js"
export * from "./repairSettingList.vue?vue&type=script&lang=js"
import style0 from "./repairSettingList.vue?vue&type=style&index=0&id=c31c9786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31c9786",
  null
  
)

export default component.exports